/* Compagnons de Cœur — Atelier embed (lot C1, 02/10/2026).
 * One script for every personalizable product page and for the single atelier page (lot I):
 *   CDCAtelier.mount(container, { productId, variantId, title, nativeSelector, entry })
 * - adopts the iframe rendered by snippets/cdc-atelier-embed.liquid ([data-cdc-atelier-frame]) or creates it, pointed at the Atelier
 *   route chosen by Shopify product ID (/atelier/fiche?productId=…&variant=…); ?ui=configurateur|historique on the page is forwarded;
 * - renders the mobile bottom bar from the iframe state (cdc-textile-bar) and relays taps (cdc-textile-bar-action), one line at every
 *   width (compact, then tight), its real height reserved at the bottom of the page;
 * - follows the iframe height and scroll requests, and its checkout redirection (shop /cart/ only);
 * - shows the fallback card if the atelier never answers (15 s) or errors; « Réessayer » reloads it;
 * - nativeSelector (optional): the theme's own purchase controls, hidden once the atelier answers and shown again with the fallback;
 * - entry (optional, lot I): 'page-atelier' on the single atelier page only, sent as &entry=page-atelier (PostHog entry_context);
 *   any other value is ignored, and product pages send nothing, so their iframe address is unchanged.
 * Calling mount again on the same container switches product in the SAME iframe, so the cart bridges (cdc-atelier-cart.js,
 * cdc-textile-cart.js), which keep the iframe element they found at load, stay connected.
 * Deferred load (mission 2026-10-10-02, product pages only): when the server-rendered iframe carries data-cdc-src and no src, the
 * address is set at the first of: the page's first photo received (LCP), window load, the block on screen or within 120 px of it, the
 * visitor's first gesture, 8 s. The E08 fallback timer starts when the address is set, not before. An iframe created here (single
 * atelier page) or rendered with a src is loaded at once, as before. */
(function () {
  'use strict';
  var ENGINE = 'https://portrait-animaux.compagnonsdecoeur.fr';
  var ID = /^\d{1,20}$/;

  function frameUrl(productId, variantId, ui, entry) {
    var url = ENGINE + '/atelier/fiche?productId=' + encodeURIComponent(productId);
    if (variantId && ID.test(String(variantId))) url += '&variant=' + encodeURIComponent(String(variantId));
    if (ui) url += '&ui=' + encodeURIComponent(ui);
    if (entry === 'page-atelier') url += '&entry=page-atelier';
    return url;
  }

  function mount(container, options) {
    if (!container || !options || !ID.test(String(options.productId))) return null;
    if (container.__cdcAtelier) { container.__cdcAtelier.show(options); return container.__cdcAtelier; }
    var doc = container.ownerDocument || document;
    var win = doc.defaultView || window;
    // ?ui=configurateur / ?ui=historique on the page is passed to the atelier, which alone decides (testers, switch).
    var pageUi = new win.URLSearchParams(win.location.search).get('ui');
    var ui = pageUi === 'configurateur' || pageUi === 'historique' ? pageUi : '';

    var frame = container.querySelector('iframe[data-cdc-atelier-frame]');
    if (!frame) {
      frame = doc.createElement('iframe');
      frame.setAttribute('data-cdc-atelier-frame', '');
      frame.setAttribute('loading', 'eager');
      frame.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
      frame.setAttribute('allow', 'fullscreen');
      container.insertBefore(frame, container.firstChild);
    }
    var fallback = container.querySelector('.cdc-textile-fallback');
    if (!fallback) {
      fallback = doc.createElement('div');
      fallback.className = 'cdc-textile-fallback';
      fallback.setAttribute('role', 'status');
      fallback.hidden = true;
      fallback.innerHTML = '<p class="cdc-fallback-title">L’atelier de personnalisation est momentanément indisponible</p>' +
        '<p class="cdc-fallback-body">Réessayez dans un instant, ou ouvrez l’atelier dans une nouvelle page.</p>' +
        '<p class="cdc-fallback-actions"><button type="button" class="cdc-fallback-retry">Réessayer</button>' +
        '<a target="_blank" rel="noopener">Ouvrir dans une nouvelle page</a></p>';
      container.appendChild(fallback);
    }
    var fallbackLink = fallback.querySelector && fallback.querySelector('.cdc-fallback-actions a');

    function send(message){ try { if (frame.contentWindow) frame.contentWindow.postMessage(message, ENGINE); } catch (_) {} }

    // Mobile bottom bar of the configurator, rendered here (fixed, outside the iframe) from the state the iframe sends
    // (cdc-textile-bar); taps are sent back (cdc-textile-bar-action). Shown only while the configurator is on screen.
    var mobile = win.matchMedia('(max-width: 1023px)');
    var state = null;
    var bar = doc.createElement('div');
    bar.id = 'cdc-textile-bar';
    bar.hidden = true;
    bar.setAttribute('role', 'group');
    bar.setAttribute('aria-label', 'Navigation de la personnalisation');
    bar.innerHTML = '<p class="cdc-bar-reason" aria-live="polite" hidden></p><div class="cdc-bar-row">' +
      '<button type="button" class="cdc-bar-back" data-action="back" aria-label="Retour">←<span>Retour</span></button>' +
      '<button type="button" class="cdc-bar-preview" data-action="preview" aria-label="Aperçu"><svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      '<path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7S2 12 2 12z" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>' +
      '<circle cx="12" cy="12" r="3" fill="none" stroke="currentColor" stroke-width="2"/></svg><span>Aperçu</span></button>' +
      '<div class="cdc-bar-group"><div class="cdc-bar-total"><small>Total</small><span></span></div>' +
      '<button type="button" class="cdc-bar-cta" data-action="cta"></button></div></div>';
    doc.body.appendChild(bar);
    var row = bar.querySelector('.cdc-bar-row'), back = bar.querySelector('.cdc-bar-back'), preview = bar.querySelector('.cdc-bar-preview');
    var total = bar.querySelector('.cdc-bar-total span'), cta = bar.querySelector('.cdc-bar-cta'), reason = bar.querySelector('.cdc-bar-reason');
    bar.addEventListener('click', function(event){
      var button = event.target.closest && event.target.closest('button[data-action]');
      if (!button || !state || button.getAttribute('aria-disabled') === 'true' || button.getAttribute('aria-hidden') === 'true') return;
      var action = { type: 'cdc-textile-bar-action', version: 1, action: button.getAttribute('data-action') };
      // Below the configurator (gallery, reviews, footer): bring it back on screen first, then apply the action.
      if (configuratorOnScreen()) { send(action); return; }
      scrollToConfigurator(0, function(){ send(action); });
    });
    function hosted(){ return Boolean(state) && mobile.matches; }
    function configuratorOnScreen(){
      var rect = frame.getBoundingClientRect();
      return rect.top < win.innerHeight - 140 && rect.bottom > 160;
    }
    // One line at every width: from the normal layout, the first level whose row does not overflow (compact: Aperçu becomes an icon;
    // tight: smaller gaps and paddings). The main button keeps its whole label.
    var fits = ['', 'compact', 'tight'];
    function fit(){
      if (bar.hidden || !row) return;
      for (var i = 0; i < fits.length; i += 1) {
        bar.setAttribute('data-fit', fits[i]);
        if (!(row.scrollWidth > row.clientWidth)) return;
      }
    }
    // The page reserves the bar's real height (its padding includes the iOS safe area) so it never covers the end of the page.
    function reserve(){ if (!bar.hidden) doc.documentElement.style.setProperty('--cdc-textile-bar-h', bar.offsetHeight + 'px'); }
    // Always shown (fixed) while the configurator is on the page, on mobile; no scroll-based logic.
    function place(){
      bar.hidden = !hosted();
      doc.body.classList.toggle('cdc-has-textile-bar', !bar.hidden);
      fit();
      reserve();
    }
    if (win.ResizeObserver) new win.ResizeObserver(reserve).observe(bar);
    // Late web fonts change the labels' widths without resizing the window.
    if (doc.fonts && doc.fonts.addEventListener) doc.fonts.addEventListener('loadingdone', place);
    function render(){
      if (!state) return;
      total.textContent = state.total;
      cta.textContent = state.loading ? 'Un instant…' : state.ctaLabel;
      cta.setAttribute('aria-disabled', state.ctaDisabled ? 'true' : 'false');
      cta.setAttribute('aria-busy', state.loading ? 'true' : 'false');
      // Atelier (Lot 2): the reason of a disabled button, shown above the bar (« Cochez la case pour ajouter au panier. »).
      if (reason) { reason.textContent = state.disabledReason || ''; reason.hidden = !(state.ctaDisabled && state.disabledReason); }
      back.setAttribute('aria-hidden', state.backVisible ? 'false' : 'true');
      back.tabIndex = state.backVisible ? 0 : -1;
      preview.style.display = state.previewVisible ? '' : 'none';
      place();
    }
    // Confirms every state to the iframe: without confirmation it shows its own bar (never a step without Continue).
    function announce(){ place(); send({ type: 'cdc-textile-bar-host', version: 1, hosted: !bar.hidden && bar.isConnected }); }
    win.addEventListener('resize', place);
    if (mobile.addEventListener) mobile.addEventListener('change', announce);

    // Smooth scroll to a point of the configurator (0 = its top), below any sticky header of the theme.
    function stickyHeaderHeight(){
      var bottom = 0;
      doc.querySelectorAll('header, [class*="header"]').forEach(function(element){
        var style = win.getComputedStyle(element);
        if (style.position !== 'fixed' && style.position !== 'sticky') return;
        var box = element.getBoundingClientRect();
        if (box.top <= 1 && box.height > 0 && box.height < win.innerHeight / 2) bottom = Math.max(bottom, box.bottom);
      });
      return bottom;
    }
    function scrollToConfigurator(offset, done){
      var top = Math.max(0, frame.getBoundingClientRect().top + win.pageYOffset + offset - stickyHeaderHeight() - 12);
      if (Math.abs(top - win.pageYOffset) > 4) win.scrollTo({ top: top, behavior: 'smooth' });
      if (!done) return;
      // Run the follow-up once the smooth scroll has settled (position stable), or after 1.2 s at most.
      var started = Date.now(), last = -1, stable = 0;
      (function watch(){
        var now = win.pageYOffset;
        stable = Math.abs(now - last) < 1 ? stable + 1 : 0;
        last = now;
        if (stable >= 3 || Date.now() - started > 1200) { done(); return; }
        win.requestAnimationFrame(watch);
      })();
    }

    // The theme's own purchase controls (if any): hidden once the atelier answers, shown again with the fallback.
    var nativeSelector = '';
    function setNative(visible){
      if (!nativeSelector) return;
      doc.querySelectorAll(nativeSelector).forEach(function(element){
        if (visible) { element.hidden = false; element.removeAttribute('aria-hidden'); }
        else { element.hidden = true; element.setAttribute('aria-hidden', 'true'); }
      });
    }

    // "Ouvrir l'atelier dans une nouvelle page" is only a fallback: shown if the iframe errors or never answers.
    var answered = false;
    var fallbackTimer = 0;
    function showFallback(){ if (!answered) { fallback.hidden = false; setNative(true); } }
    function waitForAnswer(){ win.clearTimeout(fallbackTimer); answered = false; fallbackTimer = win.setTimeout(showFallback, 15000); }
    frame.addEventListener('error', showFallback);
    // E08: « Réessayer » reloads the atelier and waits again for its first answer.
    var retry = fallback.querySelector && fallback.querySelector('.cdc-fallback-retry');
    if (retry) retry.addEventListener('click', function(){ fallback.hidden = true; frame.src = frame.src; waitForAnswer(); });

    win.addEventListener('message', function(event){
      if (event.origin !== ENGINE || event.source !== frame.contentWindow) return;
      if (!answered) { answered = true; win.clearTimeout(fallbackTimer); fallback.hidden = true; setNative(false);
        // Guide des tailles (mission 2026-10-08-17) : dit à l'Atelier, à sa première réponse, si la fiche porte la fenêtre du guide.
        send({ type: 'cdc-size-guide-host', version: 1, hosted: !!document.querySelector('[data-cdc-gt-src]') }); }
      var data = event.data || {};
      if (data.type === 'cdc-textile-height' && Number.isFinite(data.height)) frame.style.height = Math.max(400, Math.min(12000, Math.ceil(data.height))) + 'px';
      if (data.version === 1 && data.type === 'cdc-textile-scroll' && Number.isFinite(data.offset)) scrollToConfigurator(Math.max(0, data.offset));
      if (data.version === 1 && data.type === 'cdc-textile-bar' && data.visible === true && typeof data.total === 'string' && typeof data.ctaLabel === 'string') {
        state = { total: data.total, ctaLabel: data.ctaLabel, ctaDisabled: data.ctaDisabled === true, backVisible: data.backVisible === true, previewVisible: data.previewVisible === true,
          disabledReason: typeof data.disabledReason === 'string' ? data.disabledReason.slice(0, 120) : '', loading: data.loading === true };
        render();
        announce();
      }
      // The configurator leaves (navigation to the historical atelier, reload): remove the bar.
      if (data.version === 1 && data.type === 'cdc-textile-bar' && data.visible === false) { state = null; place(); }
      // L'Atelier demande le guide : la fenêtre s'ouvre sur la page, pas dans l'iframe (plus haute que l'écran). À la fermeture, le
      // focus revient à l'iframe et l'Atelier le rend à son lien.
      if (data.version === 1 && data.type === 'cdc-size-guide' && win.CDCGuideTaille) {
        win.CDCGuideTaille.open({ coupe: typeof data.coupe === 'string' ? data.coupe.slice(0, 20) : '', opener: frame,
          onClose: function(){ try { frame.focus(); } catch (_) {} send({ type: 'cdc-size-guide-closed', version: 1 }); } });
      }
      if (data.type === 'cdc-textile-checkout' && typeof data.url === 'string') {
        try {
          var destination = new URL(data.url);
          if (destination.protocol === 'https:' && destination.hostname === 'compagnonsdecoeur.fr' && destination.pathname.indexOf('/cart/') === 0) win.location.assign(destination.href);
        } catch (_) {}
      }
    });

    // Deferred load (see header): the address waits in data-cdc-src until one of the triggers fires; then the iframe loads as usual.
    var deferred = frame.hasAttribute('data-cdc-src') && !frame.getAttribute('src');
    var pendingUrl = null, armed = false, release = null;
    function armDeferred(){
      if (armed) return; armed = true;
      var cleanups = [];
      release = function(){
        if (!deferred) return;
        deferred = false;
        cleanups.forEach(function(fn){ try { fn(); } catch (_) {} });
        frame.removeAttribute('data-cdc-src');
        frame.src = pendingUrl;
        waitForAnswer();
      };
      // 1. The page's first photo (gallery slide rendered natively, 10/10/2026), already complete or once loaded (or failed).
      var photo = doc.querySelector('.cdc-first-slide img.rimage__img') || doc.querySelector('.product-gallery__main_item img');
      if (photo) {
        if (photo.complete && photo.naturalWidth > 0) { release(); return; }
        photo.addEventListener('load', release); photo.addEventListener('error', release);
        cleanups.push(function(){ photo.removeEventListener('load', release); photo.removeEventListener('error', release); });
      }
      // 2. The page is loaded.
      if (doc.readyState === 'complete') { release(); return; }
      win.addEventListener('load', release); cleanups.push(function(){ win.removeEventListener('load', release); });
      // 3. The block is on screen, or comes within 120 px of it (on a 1280 px screen the atelier is above the fold: it loads at once;
      //    on a phone it sits about 360 px below the fold and waits for the photo, unless the visitor scrolls towards it).
      if (win.IntersectionObserver) {
        var io = new win.IntersectionObserver(function(entries){ if (entries.some(function(e){ return e.isIntersecting; })) release(); }, { rootMargin: '120px 0px' });
        io.observe(container); cleanups.push(function(){ io.disconnect(); });
      }
      // 4. The visitor's first gesture (scrolling, touching, a key): they are active, the atelier must not wait.
      ['scroll', 'touchstart', 'pointerdown', 'keydown', 'wheel'].forEach(function(type){
        win.addEventListener(type, release, { passive: true, once: true }); cleanups.push(function(){ win.removeEventListener(type, release); });
      });
      // 5. Never later than 8 s after the mount.
      var timer = win.setTimeout(release, 8000); cleanups.push(function(){ win.clearTimeout(timer); });
    }

    // Points the iframe at a product (first call: keeps a server-rendered iframe already on the right address).
    function show(next){
      if (!next || !ID.test(String(next.productId))) return;
      if (next.title) frame.title = next.title;
      nativeSelector = next.nativeSelector || '';
      var url = frameUrl(String(next.productId), next.variantId, ui, next.entry);
      if (fallbackLink) fallbackLink.href = url;
      if (deferred) { pendingUrl = url; frame.setAttribute('data-cdc-src', url); armDeferred(); return; }
      if (frame.getAttribute('src') !== url) {
        state = null; place(); fallback.hidden = true;
        frame.src = url;
      }
      waitForAnswer();
    }
    var handle = { frame: frame, show: show };
    container.__cdcAtelier = handle;
    show(options);
    return handle;
  }

  window.CDCAtelier = { engine: ENGINE, frameUrl: frameUrl, mount: mount };
})();
